import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a473aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trail-bar__thumb" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "trail-bar__name" }
const _hoisted_4 = { class: "trail-bar__progress" }
const _hoisted_5 = { class: "trail-bar__progress-label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "lp-bar" }
const _hoisted_8 = { class: "trail-bar__stats" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { useLearningPathI18n } from '../view/learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    pathway: null,
    pathwayHref: null,
    sectionNumber: null,
    sectionsTotal: null
  },
  setup(__props: any) {

const props = __props as {
  pathway: any
  pathwayHref: string
  sectionNumber: number | null
  sectionsTotal: number
}



const { tl } = useLearningPathI18n();

const percentage = computed(() => Number(props.pathway.percentage_completed) || 0);

const stats = computed(() => [
  { icon: 'video', label: tl('lessons'), done: props.pathway.completed_lessons, total: props.pathway.total_lessons },
  { icon: 'flag', label: tl('challenges'), done: props.pathway.completed_challenges, total: props.pathway.total_challenges },
  { icon: 'display', label: tl('machines'), done: props.pathway.completed_machines, total: props.pathway.total_machines },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: __props.pathwayHref,
    class: "lp-card trail-bar"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (__props.pathway.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.pathway.image,
              alt: __props.pathway.name
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("small", null, _toDisplayString(_unref(tl)('trail_eyebrow')), 1),
        _createElementVNode("strong", null, _toDisplayString(__props.pathway.name), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(percentage)) + "%", 1),
            _createTextVNode(" " + _toDisplayString(_unref(tl)('percent_completed')), 1)
          ]),
          (__props.sectionNumber)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(tl)('section_of', { current: __props.sectionNumber, total: __props.sectionsTotal })), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: `${Math.min(_unref(percentage), 100)}%` })
          }, null, 4)
        ])
      ]),
      _createElementVNode("span", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats), (stat) => {
          return (_openBlock(), _createElementBlock("span", {
            key: stat.icon
          }, [
            _createVNode(HcIcon, {
              name: stat.icon,
              size: 15
            }, null, 8, ["name"]),
            _createElementVNode("strong", null, _toDisplayString(stat.done ?? 0) + "/" + _toDisplayString(stat.total ?? 0), 1),
            _createTextVNode(" " + _toDisplayString(stat.label.toLowerCase()), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})